export default {
  siteCode: 'Site 编码',
  siteName: 'Site 名称',
  siteType: 'Site 类型',
  siteType2: 'Site 类型',
  pe: 'PE',
  cancel: '禁用',
  reActivate: 'Re-activate',
  errorcode_1: '请补充完整必填信息再进行提交。',
  errorcode_6000: '此Site编码已存在，请直接在页面搜索后再进行编辑及更新。',
  enableTip: '请再次确认是否禁用该Site(s)？',
  disabledTip: '请再次确认是否启用该Site(s)？'
}
